<template>
  <v-container fluid class="paystatement-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1"
                >Pay Statement</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2"
                >Items</v-stepper-step
              >
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Pay Statement</p>
                        <v-menu
                          ref="menu_paystatementdate"
                          v-model="menu_paystatementdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_paystatement.paystatementdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_paystatement.paystatementdate"
                              v-on:change="onChangeDate($event)"
                              label="Pay Statement Date"
                              v-bind="attrs"
                              v-bind:value="new_paystatement.paystatementdate"
                              v-bind:error="error == 'paystatementdate'"
                              v-on="on"
                              single-line
                              persistent-hint
                              hint="Enter pay statement date"
                            >
                              ></v-text-field
                            >
                          </template>
                          <v-date-picker
                            v-model="new_paystatement.paystatementdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paystatementdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                onChangeDate(new_paystatement.paystatementdate);
                                $refs.menu_paystatementdate.save(new_paystatement.paystatementdate)
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_paystatementstartdate"
                          v-model="menu_paystatementstartdate"
                          :close-on-content-click="false"
                          :return-value.sync="
                            new_paystatement.paystatementstartdate
                          "
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_paystatement.paystatementstartdate"
                              label="Period Start Date"
                              v-bind="attrs"
                              v-bind:value="new_paystatement.paystatementstartdate"
                              v-bind:error="error == 'paystatementstartdate'"
                              v-on="on"
                              single-line
                              persistent-hint
                              hint="Enter period start date"
                            >
                              ></v-text-field
                            >
                          </template>
                          <v-date-picker
                            v-model="new_paystatement.paystatementstartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paystatementstartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.menu_paystatementstartdate.save(
                                  new_paystatement.paystatementstartdate
                                )
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_paystatementenddate"
                          v-model="menu_paystatementenddate"
                          :close-on-content-click="false"
                          :return-value.sync="new_paystatement.paystatementenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_paystatement.paystatementenddate"
                              label="Period End Date"
                              v-bind="attrs"
                              v-bind:value="new_paystatement.paystatementenddate"
                              v-bind:error="error == 'paystatementenddate'"
                              v-on="on"
                              single-line
                              persistent-hint
                              hint="Enter period end date"
                            >
                              ></v-text-field
                            >
                          </template>
                          <v-date-picker
                            v-model="new_paystatement.paystatementenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paystatementenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.menu_paystatementenddate.save(
                                  new_paystatement.paystatementenddate
                                )
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="
                            employees.map((x) => {
                              return { text: x.employeename, value: x._id };
                            })
                          "
                          v-model="new_paystatement.employeeid"
                          v-bind:error="error == 'employeeid'"
                          v-on:change="populateEmployeeFields"
                          outlined
                          dense
                          placeholder="Employee"
                          persistent-hint
                          single-line
                          hint="Please choose the employee"
                        >
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="new_paystatement.paystatementname"
                          v-bind:error="error == 'paystatementname'"
                          outlined
                          dense
                          placeholder="Employee Name"
                          persistent-hint
                          single-line
                          hint="Enter the Employee Name"
                        >
                        </v-text-field>
                        <v-textarea
                          v-model="new_paystatement.paystatementaddress"
                          outlined
                          rows="2"
                          label="Address"
                          hint="please enter the employee address"
                        ></v-textarea>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_paystatement.paystatementphone"
                          v-bind:error="error == 'paystatementphone'"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line
                          hint="Enter the phone"
                        >
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_paystatement.paystatementmobile"
                          v-bind:error="error == 'paystatementmobile'"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line
                          hint="Enter the mobile phone"
                        >
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_paystatement.paystatementemail"
                          v-bind:error="error == 'paystatementemail'"
                          outlined
                          dense
                          placeholder="Email"
                          persistent-hint
                          single-line
                          hint="Enter the email"
                        >
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-row no-gutters>
                          <v-col cols="12" md="6" class="mb-3 pr-1">
                            <v-select
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_paystatement.primaryCurrency"
                              v-bind:error="error == 'primaryCurrency'"
                              outlined
                              dense
                              placeholder="Currency 1"
                              persistent-hint
                              single-line hint="Currency 1">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="6" class="pl-1">
                            <v-select
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_paystatement.secondaryCurrency"
                              v-bind:error="error == 'secondaryCurrency'"
                              outlined
                              dense
                              placeholder="Currency 2"
                              persistent-hint
                              single-line hint="Currency 2">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="new_paystatement.currencyRate"
                              v-bind:error="error == 'currencyRate'"
                              :v-bind:value="1"
                              outlined
                              dense
                              placeholder="Rate"
                              persistent-hint
                              single-line hint="Rate">
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-text-field
                          class="mb-4"
                          v-model="new_paystatement.paymethod"
                          v-bind:error="error == 'paymethod'"
                          outlined
                          dense
                          placeholder="Payment Method"
                          persistent-hint
                          single-line
                          hint="Enter the pay method"
                        >
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_paystatement.paystatementnote"
                          v-bind:error="error == 'paystatementnote'"
                          outlined
                          dense
                          placeholder="Note"
                          persistent-hint
                          single-line
                          hint="Enter the note"
                        >
                        </v-text-field>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          to="/paystatement/list"
                          replace
                          outlined
                          color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          class="button-shadow"
                          color="primary"
                          @click="checkPayStatement"
                        >
                          Next
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="10">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col md="2" align="right">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="isAddTransaction=true; new_transaction={};">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-data-table
                          :headers="header_items"
                          :items="data_transactions"
                          :items-per-page="500"
                          :footer-props="footer"
                          class="elevation-0"
                        >
                          <template v-slot:item.accountid="{ item }">
                            {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="editTransactionDialog(item)">
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" @click="deleteTransaction(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="1==0"
                          class="button-shadow"
                          color="primary"
                          @click="step = 3">
                          Next
                        </v-btn>
                        <v-btn
                          v-else
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertPayStatement()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items=transsubtypes
                    v-model="new_transaction.transsubtype"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Please choose the type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items=transtypes[new_transaction.transsubtype]
                    v-model="new_transaction.transtype"
                    v-bind:error="errorindex == 12"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items="accounts.filter(account=>account.accountsubclass==new_transaction.transtype).map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.accountid"
                    v-on:change="onChangeAccount"
                    v-bind:error="errorindex == 13"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="new_transaction.transdesc"
                    v-bind:error="errorindex == 14"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="new_transaction.transnote"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Note"
                    persistent-hint
                    single-line hint="Note">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    :disabled="!isCredit[new_transaction.transsubtype]==true"
                    type="number"
                    v-model="new_transaction.transcredit"
                    v-bind:error="errorindex == 15"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Credit"
                    persistent-hint
                    single-line hint="Credit Amount">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    :disabled="!isDebit[new_transaction.transsubtype]==true"
                    type="number"
                    v-model="new_transaction.transdebit"
                    v-bind:error="errorindex == 16"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Debit"
                    persistent-hint
                    single-line hint="Debit Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items=transsubtypes
                    v-model="edit_transaction.transsubtype"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Please choose the type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items=transtypes[edit_transaction.transsubtype]
                    v-model="edit_transaction.transtype"
                    v-bind:error="errorindex == 12"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    class="mb-2"
                    :items="accounts.filter(account=>account.accountsubclass==edit_transaction.transtype).map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    v-on:change="onChangeAccount"
                    v-bind:error="errorindex == 13"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.transdesc"
                    v-bind:error="errorindex == 14"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.transnote"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Note"
                    persistent-hint
                    single-line hint="Note">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    :disabled="!isCredit[edit_transaction.transsubtype]==true"
                    type="number"
                    v-model="edit_transaction.transcredit"
                    v-bind:error="errorindex == 15"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Credit"
                    persistent-hint
                    single-line hint="Credit Amount">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    :disabled="!isDebit[edit_transaction.transsubtype]==true"
                    type="number"
                    v-model="edit_transaction.transdebit"
                    v-bind:error="errorindex == 16"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Debit"
                    persistent-hint
                    single-line hint="Debit Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import router from "@/Routes";
import { getFirstDay, getLastDay } from '../../../util/tools';

export default {
  data() {
    return {
      header_items: [
        { text: 'Type', value: 'transsubtype', width: '10%'},
        { text: 'Account', value: 'accountid', width: '15%'},
        { text: 'Description', value: 'transdesc'},
        { text: 'Note', value: 'transnote', width: '15%'},
        { text: 'Increase', value: 'transcredit', width: '10%'},
        { text: 'Decrease', value: 'transdebit', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      transactions: [],
      new_paystatement: {},
      new_transaction: {},
      edit_transaction: {},
      paystatementtypes: ["Pay Statement"],
      transsubtypes: ["Addition", "Deduction", "Contribution", "Benefit"],
      transtypes: {
        "Addition": ["Salary"],
        "Deduction": ["Salary Items"],
        "Contribution": ["Salary Items"],
        "Benefit": ["Employee Benefit"],
      },
      isCredit: {
        "Addition": true,
        "Deduction": false,
        "Contribution": true,
        "Benefit": true,
      },
      isDebit: {
        "Addition": false,
        "Deduction": true,
        "Contribution": false,
        "Benefit": true,
      },
      step: 1,
      isAddTransaction: false,
      isEditTransaction: false,
      
      menu_paystatementdate: false,
      menu_paystatementstartdate: false,
      menu_paystatementenddate: false,
      primaryCurrency: null,
      error: null,
      haserror: false,
      errorindex: null,

      footer: {'items-per-page-options': [500, 1000, 5000]},
    };
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("Employee", ["employees"]),
    ...mapState("PayStatement", ["isReceiving"]),
    data_transactions(){
      let additions = this.transactions.filter(i=>i.transsubtype=='Addition');
      let deductions = this.transactions.filter(i=>i.transsubtype=='Deduction');
      let contributions = this.transactions.filter(i=>i.transsubtype=='Contribution');
      let benefits = this.transactions.filter(i=>i.transsubtype=='Benefit');
      return [...additions, ...deductions, ...contributions, ...benefits];
    },
    data_netpay() {
      let trans = this.transactions.filter(x=>x.transsubtype=='Addition' || x.transsubtype=='Deduction');
      var list =  trans.map( trans => trans.transcredit-trans.transdebit  );
      return list.reduce((a,b)=>a+b);
    },
    data_contribution() {
      let trans = this.transactions.filter(x=>x.transsubtype=='Contribution');
      var list =  trans.map( trans => trans.transcredit-trans.transdebit  );
      return list.reduce((a,b)=>a+b);
    },
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("Employee", ["getEmployeesRequest"]),
    ...mapActions("PayStatement", ["insertPayStatementRequest"]),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    checkPayStatement() {
      if (!this.new_paystatement.paystatementdate) {
        this.error = 'paystatementdate';
        return false;
      }
      if (!this.new_paystatement.paystatementstartdate) {
        this.error = 'paystatementstartdate';
        return false;
      }
      if (!this.new_paystatement.paystatementenddate) {
        this.error = 'paystatementenddate';
        return false;
      }
      if (!this.new_paystatement.employeeid) {
        this.error = 'employeeid';
        return false;
      }
      if (!this.new_paystatement.paystatementname) {
        this.error = 'paystatementname';
        return false;
      }
      this.error = null;
      this.step = 2;
      return true;
    },
    checkTransaction(transaction){
      if(!transaction.transsubtype){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!transaction.transtype){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!transaction.accountid){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      if(!transaction.transdesc){
        this.haserrors = true;
        this.errorindex = 14;
        return false;
      }
      if(!transaction.transcredit && this.isCredit[transaction.transsubtype]==true){
        this.haserrors = true;
        this.errorindex = 15;
        return false;
      }
      if(!transaction.transdebit && this.isDebit[transaction.transsubtype]==true){
        this.haserrors = true;
        this.errorindex = 16;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    addTransaction() {
      if(this.checkTransaction(this.new_transaction)==false) return;
      let trans = Object.assign({}, this.new_transaction, {id: Math.floor(Math.random() * Math.pow(10, 10))});
      this.transactions.push(trans);
      this.isAddTransaction = false;
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans) => trans.id == item.id);      
      if(index!=-1) this.transactions.splice(index,1);
    },
    editTransactionDialog(item){      
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      if(this.checkTransaction(this.edit_transaction)==false) return;
      this.isEditTransaction = false;
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = Object.assign({}, this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.edit_transaction = {};
    },
    populateEmployeeFields(employeeid) {
      let employee = this.employees.find((employee) => employee._id == employeeid);
      this.new_paystatement.paystatementname = employee.employeename;
      this.new_paystatement.paystatementaddress = employee.employeeaddress;
      this.new_paystatement.paystatementphone = employee.employeephone;
      this.new_paystatement.paystatementmobile = employee.employeemobile;
      this.new_paystatement.paystatementemail = employee.employeeemail;
      this.new_paystatement.paymethod = employee.paymethod;
    },
    async insertPayStatement() {
      let payload = {
        paystatement: this.new_paystatement,
        transactions: this.transactions,
      };
      
      await this.insertPayStatementRequest(payload);
      router.push("/paystatement/list");
    },

    onChangeDate(value) {
      let date = new Date(value);
      let start_date = getFirstDay(date);
      let end_date = getLastDay(date);
      this.new_paystatement = Object.assign({}, this.new_paystatement, {paystatementstartdate: start_date, paystatementenddate: end_date});
    },
    onChangeAccount(accountid){
      let account = this.accounts.find(x=>x._id==accountid);
      this.new_transaction = Object.assign(this.new_transaction, {transdesc: account.accountname});
    },
    onChangeAccountEdit(accountid){
      let account = this.accounts.find(x=>x._id==accountid);
      this.edit_transaction = Object.assign(this.edit_transaction, {transdesc: account.accountname});
    },
  },

  async created() {
    if (this.accounts.length == 0) await this.getAccountsRequest();
    if (this.employees.length == 0) await this.getEmployeesRequest();
    let currency = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryCurrency'}, );
    let isTaxable = await this.getSetting({code: 'TaxSettings', name: 'isTaxEnabled'}, );
    this.new_paystatement = Object.assign({}, this.new_paystatement, {primaryCurrency: currency, secondaryCurrency: currency, currencyRate: 1, isTaxable: isTaxable});
    console.log(this.new_paystatement)
  },
};
</script>

<style src="./Add.scss" lang="scss"></style>
